import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';

import { updateCargoOrder } from 'actions/cargoes/orders';
import { Checkbox, MenuItem, SelectField } from 'material-ui';

import helpers from 'helpers';

class Dangerous extends React.Component {
    constructor(props) {
        super(props);

        this.onChangeDangerousClass = this.onChangeDangerousClass.bind(this);
        this.onChangeDangerousUnNumber = this.onChangeDangerousUnNumber.bind(this);
    }

    onChangeDangerousClass(e) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        if (typeof newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous === 'undefined') {
            newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous = {
                class: [],
                unNumber: '',
            };
        }

        const value = helpers.clearLetters(e.target.value);

        newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous.class[0] = 
            value || undefined;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeDangerousUnNumber(e) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        
        if (typeof newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous === 'undefined') {
            newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous = {
                class: [],
                unNumber: '',
            };
        }

        const value = helpers.clearLetters(e.target.value);

        if (value.length > 4) {
            return;
        }

        newCargoOrder.cargo[this.props.cargoPackingIndex].dangerous.unNumber = 
            value || undefined;
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    onChangeValues = (path, value) => {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        _.set(newCargoOrder.cargo[this.props.cargoPackingIndex], path, value);
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    };

    render() {
        const cargoData = this.props.cargoOrder.cargo[this.props.cargoPackingIndex];

        return (
            <div>
                <div className='row'>
                    <div className='one-third' style={{ justifyContent: 'space-evenly' }}>
                        <span style={{ display: 'block', fontSize: '13px', alignSelf: 'center' }}>Stw Factor:</span>
                        <TextField
                            style={{ fontSize: '13px', width: '25px' }}
                            value={cargoData.packing.pack.sf}
                            hintText='SF'
                            onChange={e => 
                                this.onChangeValues('packing.pack.sf', helpers.clearLetters(e.target.value))
                            }
                        />
                        <SelectField
                            hintText='cbm/mt'
                            style={{ width: '71px', fontSize: '13px' }}
                            value={cargoData.packing.pack.sfUnit}
                            hintStyle={{ fontSize: '13px' }}
                            iconStyle={{ 
                                padding: '12px 0', width: 'unset', height: 'unset',
                            }}
                            onChange={(_e, _i, value) => this.onChangeValues('packing.pack.sfUnit', value)}
                            labelStyle={{ paddingRight: 0 }}
                            autoWidth
                        >
                            <MenuItem value='cbm/mt' primaryText='cbm/mt' />
                            <MenuItem value='cbf/mt' primaryText='cbf/mt' />
                        </SelectField>
                    </div>
                    <div className='one-third' style={{ justifyContent: 'space-evenly' }}>
                        <Checkbox 
                            style={{ width: 'unset', alignSelf: 'center' }}
                            checked={cargoData.dangerous.value}
                            labelStyle={{ display: 'none' }}
                            onCheck={() => this.onChangeValues('dangerous.value', !cargoData.dangerous.value)}
                        />
                        <span 
                            style={{ 
                                display: 'block', width: '77px', fontSize: '13px', alignSelf: 'center',
                            }}
                        >
                            Dangerous Class (IMDG)
                        </span>
                        <TextField
                            style={{ fontSize: '13px', width: '42px' }}
                            value={(cargoData.dangerous && cargoData.dangerous.class[0]) || ''}
                            hintText='Class'
                            onChange={this.onChangeDangerousClass}
                        />
                    </div>
                    <div className='one-third' style={{ justifyContent: 'space-evenly' }}>
                        <span 
                            style={{ 
                                display: 'block', width: '96px', fontSize: '13px', alignSelf: 'center',
                            }}
                        >
                            Dangerous Good UnNumber (UN)
                        </span>
                        <TextField
                            style={{ fontSize: '13px', width: '61px' }}
                            value={(cargoData.dangerous && cargoData.dangerous.unNumber) || ''}
                            hintText='unNumber'
                            onChange={this.onChangeDangerousUnNumber}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        numberOrderTable: ownProps.numberOrderTable,
        cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
    }),
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(Dangerous);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Dangerous.jsx